// GraphQLエラーの型定義
interface GraphQLError {
  message: string;
  extensions?: Record<string, unknown>;
}

// エラーのような構造を持つオブジェクトの型定義
type ErrorLike = Error | GraphQLError | { message: string } | null | undefined;

/**
 * Over Capacityエラーかどうかを判定
 */
export function isOverCapacityError(error: ErrorLike | string): boolean {
  if (!error) {
    return false;
  }

  if (typeof error === "string") {
    return error.includes("Over Capacity:");
  }

  if (typeof error === "object" && "message" in error) {
    return error.message.includes("Over Capacity:");
  }

  return false;
}

/**
 * Over Capacityエラーからエラータイプを抽出
 */
export function getOverCapacityType(error: ErrorLike | string): string | null {
  if (!isOverCapacityError(error)) {
    return null;
  }

  const message =
    typeof error === "string" ? error : (error as { message: string }).message;
  const match = message?.match(/Over Capacity:\s*(.+)/);
  return match?.[1]?.trim() ?? null;
}

/**
 * Over Capacityエラーの詳細情報を取得
 */
export interface OverCapacityInfo {
  isOverCapacity: boolean;
  type: string | null;
  originalMessage: string;
}

export function getOverCapacityInfo(error: ErrorLike): OverCapacityInfo {
  if (!error || typeof error !== "object" || !("message" in error)) {
    return {
      isOverCapacity: false,
      type: null,
      originalMessage: "",
    };
  }

  return {
    isOverCapacity: isOverCapacityError(error),
    type: getOverCapacityType(error),
    originalMessage: error.message,
  };
}
